import AuthenticatedIframe from '../AuthenticatedIframe';

interface Props {
    systemId: string;
    page: 'iot-connection' | 'telemetry' | 'maintenance' | 'notifications' | 'service';
    onMessage?: (data: unknown) => void;
}

const SystemConditionMonitoringIframe = ({ systemId, page, onMessage }: Props) => {
    const base = process.env.REACT_APP_BUSCH_IOT_URL;
    const src = page === 'iot-connection'
        ? `${base}/iot-systems/iotSystemRegistration/${systemId}`
        : `${base}/iot-systems/${systemId}/${page}`;
    return <AuthenticatedIframe src={src} title={page} onMessage={onMessage} />;
};

export default SystemConditionMonitoringIframe;
